import type { FormControl } from '@angular/forms';

export enum SetupSecurityPhoneModalState {
  PENDING,
  REQUEST_CHANGE,
  SETUP,
}

export enum SetupSecurityPhoneStatus {
  CANCELLED,
  SUCCESS,
}

export enum PhoneVerificationDeliveryMethod {
  SMS = 'sms',
  WHATSAPP = 'whatsapp',
  CALL = 'call',
}

export interface PhoneVerificationInputForm {
  country: FormControl<string>;
  phoneNumber: FormControl<string>;
}
